import initialState from './initial';

const UserReducer = (state = initialState.user, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'USER_UPDATED': {
            const { user } = payload;
            return { ...user, name: `${user.firstName} ${user.lastName}`, loading:false };
        }

        default:
            return state;
    }
};
export default UserReducer;
